export default "__VITE_ASSET__BIczjcGb__"